module.exports = __webpack_public_path__ + "static/media/ATM.4b0662c4.jpg";